import type { GlobalState } from '../../../main/types/redux';
import type { AuthState } from '../types';

export const getAuthState = (state: GlobalState): AuthState =>
  state.auth;
